<template>
    <teleport to="#main-menu-target">
        <transition :duration="500">
            <div class="ui-header-popup" v-if="active" @click.self="active = false">
                <div class="ui-header-popup-bg">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script setup lang="ts">
import { useDialogStore } from '~/store/dialogStore';


const props = defineProps<{
    code: string;
}>();

const active = defineModel<boolean>();

const { $listen, $event } = useNuxtApp();

const dialogStore = useDialogStore();
watch(active, () => {
    dialogStore.set(props.code, active.value ?? false);
    if (active.value) {
        $event('free-header-dialog', props.code);
    }
}, {
    immediate: true
});


$listen('free-header-dialog', (code: string) => {
    console.log(code)
    if (props.code !== code) {
        active.value = false;
    }
});


</script>

<style lang="scss" scoped>

.ui-header-popup {
    position: fixed;
    top: var(--header-position, 0px);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgb(22,22,22,.22);
    overflow: hidden;
    transition: background .1s;
}

.ui-header-popup-bg {
    width: 100%;
    position: relative;
    z-index: 100;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    gap: 7px;
    box-shadow: 0 4px 4px rgba(22,22,22,.1);
    max-height: calc(95vh - var(--header-position));
    top: 0;
    transition: top .25s ease;
}


.ui-header-popup.v-leave-from,
.ui-header-popup.v-enter-to{
    background: rgb(22,22,22,.22);

    .ui-header-popup-bg {
        top: 0;
    }
}

.ui-header-popup.v-leave-to,
.ui-header-popup.v-enter-from{
    background: rgb(22,22,22,0);

    .ui-header-popup-bg {
        top: -100vh;
    }
}

</style>